import { render, staticRenderFns } from "./demoLogin.vue?vue&type=template&id=dcf03ac8"
import script from "./demoLogin.vue?vue&type=script&lang=js"
export * from "./demoLogin.vue?vue&type=script&lang=js"
import style0 from "./demoLogin.vue?vue&type=style&index=0&id=dcf03ac8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports